module.exports = __webpack_public_path__ + "img/next-disabled.53934a98.svg";